import React, { useCallback } from 'react';

import { QuickFindSkeleton as QuickFindSkeletonInternal } from '@atlassian/search-page/quick-find-skeleton';

import { LoadableAfterPaint } from '@confluence/loadable';
import { useRouteActions } from '@confluence/route-manager';
import { CONTEXT_PATH } from '@confluence/named-routes';
import { useIsNav4Enabled } from '@confluence/nav4-enabled';

export const QuickFindSkeleton = () => {
	const { push } = useRouteActions();
	const isNav4Enabled = useIsNav4Enabled();
	const onEnter = useCallback(
		(e: React.KeyboardEvent) => {
			const input = e.target as HTMLInputElement;
			input.blur();
			push(`${CONTEXT_PATH}/search/?text=${input.value}`);
		},
		[push],
	);

	return <QuickFindSkeletonInternal onEnter={onEnter} isNav4Enabled={isNav4Enabled} />;
};

export const QuickFindAsync = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-QuickFind" */ './QuickFind')).QuickFind,
	loading: () => <QuickFindSkeleton />,
});
